/* LegBilligt — GAVEINDPAKNING I KURVEN
   =========================================================================
   Hoerer sammen med snippets/lb-gaveindpak.liquid (al logik og alle tekster),
   sections/lb-gaveindpak.liquid (skallen, saa Shopify kan tegne blokken
   forfra) og assets/lb-gaveindpak.css.

   DEN VIGTIGSTE REGEL I HELE FILEN:
   Denne fil laegger ALDRIG gaveindpakning i en kurv, som kunden ikke selv har
   bedt om. Forbrugeraftalelovens §31 kraever udtrykkeligt samtykke til enhver
   ekstrabetaling, og et forudkrydset felt er ikke et samtykke. Derfor kan et
   kald, der oeger antallet, kun opstaa af to ting:
     1) kunden har klikket paa en knap i boksen, eller
     2) tilstanden er 'alle' — og den tilstand kan KUN opstaa af et klik,
        fordi Liquid nulstiller den til 'fra', saa snart der ikke ligger en
        indpakningslinje i kurven.
   Aendrer nogen paa det, aendrer de butikkens retsstilling. Laes hele
   forklaringen i snippets/lb-gaveindpak.liquid foer du roerer noget.

   Ingen MutationObserver (forbudt i projektet) og ingen alert().
   ========================================================================= */
(function () {
  'use strict';

  /* Variant-id paa varen "Gaveindpakning" (SKU GAVEINDPAK).
     Staar ogsaa i snippets/lb-gaveindpak.liquid og i assets/lb-gaveindpak.css
     — rettes ét sted, skal det rettes alle tre. */
  var VARIANT = 54049319911771;
  var SEKTION = 'lb-gaveindpak';

  var ROD = '/';
  try {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      ROD = window.Shopify.routes.root;
    }
  } catch (e) { /* ROD bliver '/' */ }
  var KURV = ROD + 'cart';

  /* ---------------------------------------------------------------------
     TILSTANDEN LAESES FRA SIDEN, IKKE FRA EN VARIABEL
     ---------------------------------------------------------------------
     Blokken bliver kasseret og tegnet forfra af Liquid ved hver eneste
     aendring i kurven. En variabel her i filen ville derfor vaere foraeldet
     praecis naar det gaelder. Sandheden staar i <span class="lbg-data">,
     som Liquid skriver hver gang — inde i blokken, fordi temaet kun skifter
     blokkens innerHTML ud og ikke dens attributter. */
  function data() {
    var el = document.querySelector('#lb-gaveindpak .lbg-data');
    if (!el) { return null; }
    var egnet = parseInt(el.getAttribute('data-egnet'), 10);
    var gave = parseInt(el.getAttribute('data-gave'), 10);
    if (isNaN(egnet) || egnet < 0) { egnet = 0; }
    if (isNaN(gave) || gave < 0) { gave = 0; }
    return {
      egnet: egnet,
      gave: gave,
      tilstand: el.getAttribute('data-tilstand') || 'fra'
    };
  }

  /* Hvor mange indpakninger BOER der ligge i kurven, som den ser ud nu?
     Det er hele regelsaettet paa fem linjer:
       ingen egnede varer  ->  0, og tilstanden nulstilles
       alle                ->  lig antallet af egnede varer
       fast                ->  kundens eget tal, klippet ned til antal_egnet
       fra                 ->  det, der ligger (nul) — vi tilfoejer ingenting
     Bemaerk at 'fra' returnerer gave og ikke 0: saa kan funktionen aldrig
     komme til at FJERNE noget, kunden lige har lagt i, og aldrig komme til
     at TILFOEJE noget i en kurv, der er slukket. */
  function oensket(d) {
    if (d.egnet <= 0) { return 0; }
    if (d.tilstand === 'alle') { return d.egnet; }
    if (d.tilstand === 'fast') { return Math.min(d.gave, d.egnet); }
    return d.gave;
  }

  /* ---------------------------------------------------------------------
     VAGTEN MOD UENDELIGE LOEKKER
     ---------------------------------------------------------------------
     Faren er reel: i tilstanden 'alle' RETTER denne fil antallet, naar det
     ikke passer. Rettelsen aendrer kurven. En aendret kurv gengiver blokken.
     En gengivet blok faar os til at kigge efter igen. Det er en cirkel, og
     den slutter kun, fordi Liquid saa svarer med et tal, der passer.

     Svarer Liquid IKKE med et tal, der passer — Shopify afviser antallet,
     varen er udgaaet, en app skriver linjen om bagefter — ville cirklen koere
     for evigt og sende et kald af sted hvert halve sekund.

     VAGTEN ER EN SIGNATUR, ikke en taeller. Foer vi sender en rettelse,
     skriver vi kurvens tilstand ned: "egnet:gave:tilstand". Naar blokken er
     tegnet igen, sammenligner vi:

       - er tilstanden en ANDEN end den, vi rettede fra, virkede rettelsen
         (eller kunden har lavet noget om) -> vi maa gerne handle igen
       - er tilstanden PRAECIS den samme, gjorde rettelsen ingen forskel
         -> vi stopper og roerer ikke kurven igen

     Én rettelse pr. tilstand, altsaa. En loekke kan ikke opstaa, fordi den
     anden omgang altid ser den samme signatur som den foerste.

     Signaturen nulstilles to steder: naar tallet passer (alt er godt), og
     naar kunden selv klikker (hendes beslutning skal aldrig blokeres af en
     vagt, der er sat op mod vores egen automatik).

     iGang er den anden halvdel: mens et kald er undervejs, og mens siden
     tegner sig faerdig bagefter, kigger vi slet ikke. Uden den ville vi
     naa at laese en halvgammel blok og rette efter forkerte tal. */
  var iGang = false;
  var sidsteRettelse = null;

  function laas(paa) {
    var blok = document.getElementById('lb-gaveindpak');
    if (!blok) { return; }
    if (paa) { blok.setAttribute('data-lbg-laast', '1'); }
    else { blok.removeAttribute('data-lbg-laast'); }
  }

  function synk() {
    if (iGang) { return; }
    var d = data();
    if (!d) { sidsteRettelse = null; return; }

    var vil = oensket(d);
    var sig = d.egnet + ':' + d.gave + ':' + d.tilstand;

    if (vil === d.gave) { sidsteRettelse = null; return; }
    if (sidsteRettelse === sig) { return; }   /* <- vagten */

    sidsteRettelse = sig;
    saet(vil, vil > 0 ? d.tilstand : '');
  }

  /* ---------------------------------------------------------------------
     ÉT KALD SAETTER BAADE ANTAL OG TILSTAND
     ---------------------------------------------------------------------
     /cart/update.js kan tre ting paa én gang, og det er derfor den og ikke
     add.js/change.js bruges her:
       - den TILFOEJER linjen, hvis variant-id'et ikke ligger i kurven
       - den AENDRER antallet, hvis den goer
       - den FJERNER linjen ved antal 0
     ... og den skriver cart-attributten i samme forespoergsel. To kald ville
     betyde, at kurven i et oejeblik havde et antal uden en tilstand — og
     lige praecis der kunne en gengivelse naa at laese en tilstand, der ikke
     passer til antallet. */
  function saet(antal, tilstand) {
    if (iGang) { return Promise.resolve(); }
    iGang = true;
    laas(true);

    var opdat = {};
    opdat[VARIANT] = antal;

    return fetch(ROD + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        updates: opdat,
        attributes: { 'lb-gaveindpak': (antal > 0 && tilstand) ? tilstand : '' }
      })
    })
      .then(function (r) {
        if (!r.ok) { throw new Error('kurven svarede ' + r.status); }
        return r.json();
      })
      .then(function () { return gentegn(); })
      .catch(function (fejl) {
        /* Ingen alert(). Gaar det galt, staar boksen med det, kurven rent
           faktisk indeholder — kunden er ikke blevet opkraevet for noget,
           hun ikke kan se. Naeste gengivelse retter visningen af sig selv. */
        console.log('[lb-gaveindpak]', fejl); // eslint-disable-line
        return hentEgenBlok();
      })
      .then(function () {
        iGang = false;
        laas(false);
      });
  }

  /* ---------------------------------------------------------------------
     GENTEGNINGEN — TEMAETS EGEN, IKKE VORES
     ---------------------------------------------------------------------
     KURVESIDEN: sections/lb-kurv-tema.liquid pakker window.fetch ind og
     henter HELE .cc-main-cart forfra ved ethvert /cart/update (nyKurv).
     Vores blok ligger inde i .cc-main-cart og kommer med af sig selv — baade
     boksen, varelisten og subtotalen. Vi roerer ingenting; to stykker kode om
     samme opgave giver kun kaploeb. Se kommentaren ved nyKurv() i den fil.

     KURVSKUFFEN: temaets <cart-drawer> har sin egen refreshCartDrawer(),
     som assets/cart-items.js ogsaa selv kalder. Den henter skuffen forfra
     med subtotal og det hele.

     Begge veje tager et oejeblik. Vi holder iGang oppe imens, saa synk()
     ikke naar at laese en blok, der endnu viser de gamle tal. */
  function vent(ms) {
    return new Promise(function (ok) { setTimeout(ok, ms); });
  }

  function gentegn() {
    if (document.querySelector('.cc-main-cart')) { return vent(900); }

    var skuffe = document.getElementById('cart-drawer');
    if (skuffe && typeof skuffe.refreshCartDrawer === 'function') {
      try { skuffe.refreshCartDrawer(true); return vent(900); }
      catch (e) { /* falder igennem til vores egen */ }
    }
    return hentEgenBlok();
  }

  /* Sidste udvej: hent kun vores egen sektion. Bruges, hvor hverken
     kurvesiden eller en aaben skuffe kan gentegne for os.
     /cart og ikke forsiden: forsiden er cachet og kan svare med en gammel
     kurv — den faelde er beskrevet i assets/lb-kurvboble.js. */
  function hentEgenBlok() {
    return fetch(KURV + '?sections=' + SEKTION, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j[SEKTION]) { return; }
        var mal = document.getElementById('lb-gaveindpak');
        if (!mal) { return; }
        var t = document.createElement('template');
        t.innerHTML = j[SEKTION];
        var ny = t.content.querySelector('.lb-gaveindpak');
        mal.innerHTML = ny ? ny.innerHTML : '';
      })
      .catch(function () { /* saa staar der bare det, der stod */ });
  }

  /* ---------------------------------------------------------------------
     BLOKKEN SKAL MED, NAAR TEMAET SELV GENTEGNER KURVEN
     ---------------------------------------------------------------------
     assets/cart-items.js samler i getSectionsToRender() de sektioner, den
     beder Shopify tegne forfra ved hver aendring i varelisten: kurveikonet,
     fri fragt-bjaelken, varelisten og ordreoversigten. Vi haenger vores egen
     sektion paa listen.

     HVORFOR UDEFRA OG IKKE I TEMAETS FIL: assets/cart-items.js er temaets
     egen og bliver overskrevet ved en temaopdatering. Stod tilfoejelsen dér,
     ville blokken en dag holde op med at foelge kurven, uden at nogen
     opdagede det — den ville bare vise et forkert antal. Her overlever den.

     Temaet springer selv posten over, hvis elementet ikke findes
     (if (!sectionEl) return), saa den goer ingen skade paa sider uden kurv.

     BEMAERK GRAENSEN PAA FEM: Section Rendering API'et tegner hoejst fem
     sektioner pr. kald. Kurvesiden bruger tre forskellige (kurveikon, fri
     fragt, selve kurvesektionen) og skuffen tre. Med vores er der fire.
     Laegges der flere paa listen en dag, er det dét loft, der braender
     foerst — og saa holder den sidste paa listen op med at blive tegnet. */
  function haengPaa() {
    var K = window.customElements && customElements.get('cart-items');
    if (!K || !K.prototype || K.prototype.lbGaveHaengt) { return; }
    var org = K.prototype.getSectionsToRender;
    if (typeof org !== 'function') { return; }
    K.prototype.lbGaveHaengt = true;
    K.prototype.getSectionsToRender = function () {
      var liste = org.call(this);
      liste.push({ id: 'lb-gaveindpak', section: SEKTION, selector: '.lb-gaveindpak' });
      return liste;
    };
  }

  haengPaa();
  try {
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('cart-items').then(haengPaa, function () {});
    }
  } catch (e) { /* saa er der ingen kurv paa siden */ }

  /* ---------------------------------------------------------------------
     KLIKKENE
     ---------------------------------------------------------------------
     Lyttet paa document og ikke paa knapperne. Blokken bliver kasseret og
     tegnet forfra ved hver aendring, saa en lytter paa selve knappen ville
     vaere vaek efter foerste klik — og at haenge den paa igen kraever, at man
     opdager gengivelsen. Det er praecis dét, en MutationObserver plejer at
     blive brugt til, og den er forbudt her. Delegering loeser det uden. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) { return; }
    var knap = e.target.closest('#lb-gaveindpak [data-lbg]');
    if (!knap) { return; }
    e.preventDefault();
    if (iGang) { return; }

    var d = data();
    if (!d) { return; }

    /* Kundens eget klik. Vagten mod loekker er sat op mod VORES automatik og
       maa aldrig staa i vejen for en beslutning, hun lige har truffet. */
    sidsteRettelse = null;

    var h = knap.getAttribute('data-lbg');

    if (h === 'alle') {
      if (d.egnet > 0) { saet(d.egnet, 'alle'); }
      return;
    }
    if (h === 'en') {
      if (d.egnet > 0) { saet(1, 'fast'); }
      return;
    }
    if (h === 'fjern') {
      saet(0, '');
      return;
    }
    if (h === 'plus') {
      /* Aldrig flere indpakninger end der er varer at pakke ind i. */
      var op = Math.min(d.gave + 1, d.egnet);
      if (op !== d.gave) { saet(op, 'fast'); }
      return;
    }
    if (h === 'minus') {
      /* Taeller kunden ned fra "alle", er det ikke laengere "alle" — hun har
         valgt et bestemt antal, og saa skal det tal ikke vokse igen, naeste
         gang hun laegger noget i kurven. */
      var ned = d.gave - 1;
      if (ned <= 0) { saet(0, ''); } else { saet(ned, 'fast'); }
    }
  });

  /* ---------------------------------------------------------------------
     HVORNAAR KIGGER VI EFTER
     ---------------------------------------------------------------------
     Ved sideindlaesning, og efter enhver aendring af kurven. Alle veje til en
     aendret kurv ender i et kald til /cart/add, /cart/change, /cart/update
     eller /cart/clear — vi lytter dér i stedet for paa knapper, vi ikke
     kender endnu. Samme greb som assets/lb-kurvboble.js.

     TO GANGE, 450 ms og 1300 ms efter svaret: temaet skifter foerst
     blokkens indhold ud et lille stykke tid EFTER at kaldet er faerdigt, og
     paa kurvesiden henter sections/lb-kurv-tema.liquid oven i koebet hele
     sektionen forfra i et kald mere. Laeser vi for tidligt, laeser vi de
     gamle tal. Det koster ingenting at kigge to gange: er tallet allerede
     rigtigt, goer synk() ingenting, og er tilstanden uaendret, stopper
     vagten den anden omgang. */
  var ur1 = null, ur2 = null;
  function planlaeg() {
    clearTimeout(ur1); clearTimeout(ur2);
    ur1 = setTimeout(synk, 450);
    ur2 = setTimeout(synk, 1300);
  }

  if (window.fetch) {
    var oprindelig = window.fetch;
    window.fetch = function () {
      var svar = oprindelig.apply(this, arguments);
      try {
        var u = arguments[0];
        if (u && typeof u !== 'string' && u.url) { u = u.url; }
        if (typeof u === 'string' && (
          u.indexOf('/cart/add') > -1 ||
          u.indexOf('/cart/change') > -1 ||
          u.indexOf('/cart/update') > -1 ||
          u.indexOf('/cart/clear') > -1
        )) {
          if (svar && svar.then) { svar.then(planlaeg, function () {}); }
        }
      } catch (e) { /* aldrig i vejen for selve kaldet */ }
      return svar;
    };
  }

  document.addEventListener('on:cart:change', planlaeg);
  document.addEventListener('on:line-item:change', planlaeg);
  document.addEventListener('cart:refresh', planlaeg);
  document.addEventListener('shopify:section:load', planlaeg);

  function start() { synk(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  /* Tilbage-knappen i browseren viser siden fra bfcache uden at koere noget.
     Ligger der en kurv fra foer, skal den kigges efter én gang. */
  window.addEventListener('pageshow', function (e) { if (e.persisted) { planlaeg(); } });
})();
